import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisionaryLeadership from "./sections/VisionaryLeadership";
import TheBrokenSystem from "./sections/TheBrokenSystem";
import StoriesFromTheField from "./sections/StoriesFromTheField";
import LatestGovernanceUpdates from "./sections/LatestGovernanceUpdates";
import SecureEngagement from "./sections/SecureEngagement";
import FutureCollaborations from "./sections/FutureCollaborations";
import WealthloopedFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisionaryLeadership />
      <TheBrokenSystem />
      <StoriesFromTheField />
      <LatestGovernanceUpdates />
      <SecureEngagement />
      <FutureCollaborations />
      <WealthloopedFooter />
    </div>;
}